import React from 'react';
import BranchAbout from './branch-about';
import BranchMap from './branch-map';

const Branch = () => (
  <div className="item-section item-section-full-width">
    <div className="row">
      <div className="col-md-6">
        <BranchAbout />
      </div>
      <div className="col-md-6">
        <div className="m-t hidden-md" />
        <BranchMap />
      </div>
    </div>
  </div>
);

export default Branch;
